import { render, staticRenderFns } from "./bob-dropdown.vue?vue&type=template&id=5efddf89&scoped=true"
import script from "./bob-dropdown.vue?vue&type=script&lang=js"
export * from "./bob-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efddf89",
  null
  
)

export default component.exports